// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Chip/Basic.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Chip, ChipList} from '@sail/ui';
import {Container} from './common';

export const Basic = () => (
  <Container>
    <ChipList>
      <Chip
        label="Currency"
        value="USD"
        onDropdown={() => {
          // eslint-disable-next-line no-alert
          alert('Dropdown function triggered');
        }}
        onClose={() => {
          // eslint-disable-next-line no-alert
          alert('Close function triggered');
        }}
      />
      <Chip
        label="Status"
        value="Succeeded"
        onDropdown={() => {
          // eslint-disable-next-line no-alert
          alert('Dropdown function triggered');
        }}
        onClose={() => {
          // eslint-disable-next-line no-alert
          alert('Close function triggered');
        }}
      />
      <Chip
        label="Amount"
        onAddSuggestion={() => {
          // eslint-disable-next-line no-alert
          alert('Add Amount suggestion');
        }}
      />
      <Chip
        label="Date"
        onAddSuggestion={() => {
          // eslint-disable-next-line no-alert
          alert('Add Date suggestion');
        }}
      />
    </ChipList>
  </Container>
);
